module.exports = __webpack_public_path__ + "10_mole.7369ee6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer3/10_mole.png
// module id = bWYI
// module chunks = 0